import React, { Component } from 'react';
import _ from 'lodash';
import { Message, Button, Form } from 'semantic-ui-react';
// import { log } from '@emyw/core-lib';
import SocialLoginButtonExtension from '../SocialLoginButton/SocialLoginButtonExtension';
import SocialLoginButton from '../SocialLoginButton/SocialLoginButton';
import { normalizeErrors } from '../utils';
import '../primitives.css';

/** Social Login Form is intended as a reusable social login component that may be used by multiple clients
 * (i.e. web app, website, browser extension, etc..)
 * <br />
 * <h3>Browser Extension Mode</h4>
 * The component must send a message to the background script when in browser extension mode. It determines if this mode is active
 * when the env variable REACT_APP_CHROME_EXTENSION_MODE is true.
 * <br /><br />
 * <hr />
 * <br />
 * <div>
 * <h4>Back-end Requirements</h4>
 * A backend graphql api endpoint, <a rel=noopener href="https://github.com/emyw/auth-api">auth-api</a>,
 * is needed for this login form to function.
 * <h4>Local Login</h4>
 * <h4>Social Login</h4>
 * Included are social login buttons for facebook and google which obtain an access token.<br />
 * </div>
 */
class SocialLoginForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isSubmitting: false,
      errors: ''
    };
    this.onSocialLogin = this.onSocialLogin.bind(this);
  }
  onSocialLogin(user) {
    // log.trace('social user:', user);
    if (!user) this.setState({
      isSubmitting: false
    });
    /** Parse the resulting object a little differently since it used getters and settings with underscored object names.
     * This doesn't serialize to JSON well if we want to do that later. */
    const {
      profile,
      provider,
      token
    } = user;
    const user2 = {
      profile,
      provider,
      token
    };
    // log.trace(user2.provider, user2);
    if (this.props.onSocialLoginSuccess) this.props.onSocialLoginSuccess(user2.provider, user2);else log.warn('onSocialLoginSuccess prop required but not provided');
  }
  onLoginFailureInternal(onLoginFailure, err) {
    this.setState({
      isSubmitting: false
    });
    if (onLoginFailure) {
      onLoginFailure(err);
    } else {
      this.setState({
        errors: normalizeErrors({
          path: 'socialLogin',
          message: err
        })
      });
    }
  }
  render() {
    const {
      REACT_APP_CHROME_EXTENSION_MODE,
      REACT_APP_GOOGLE_APP_ID,
      REACT_APP_FACEBOOK_APP_ID
    } = process.env;
    const {
      onLoginFailure
    } = this.props;
    const {
      isSubmitting,
      errors
    } = this.state;
    const fbButton = /*#__PURE__*/React.createElement(Button, {
      className: "square",
      size: "large",
      type: "button",
      content: "Facebook",
      icon: "facebook",
      onClick: () => this.setState({
        isSubmitting: true
      }),
      disabled: isSubmitting,
      color: "facebook",
      fluid: true
    });
    const gpButton = /*#__PURE__*/React.createElement(Button, {
      className: "square",
      size: "large",
      type: "button",
      content: "Google",
      icon: "google",
      onClick: () => this.setState({
        isSubmitting: true
      }),
      disabled: isSubmitting,
      color: "google plus",
      fluid: true
    });
    const extensionMode = /^true$/i.test(REACT_APP_CHROME_EXTENSION_MODE || false);
    // log.trace(extensionMode ? 'extension mode enabled' : 'extension mode not enabled');

    const fbSocialButton = React.cloneElement(extensionMode ? /*#__PURE__*/React.createElement(SocialLoginButtonExtension, null, fbButton) : /*#__PURE__*/React.createElement(SocialLoginButton, null, fbButton), {
      provider: 'facebook',
      appId: REACT_APP_FACEBOOK_APP_ID,
      scopes: 'email',
      onLoginSuccess: this.onSocialLogin,
      onLoginFailure: err => {
        this.onLoginFailureInternal(onLoginFailure, err);
      }
    });
    const gpSocialButton = React.cloneElement(extensionMode ? /*#__PURE__*/React.createElement(SocialLoginButtonExtension, null, gpButton) : /*#__PURE__*/React.createElement(SocialLoginButton, null, gpButton), {
      provider: 'google',
      appId: REACT_APP_GOOGLE_APP_ID,
      scopes: 'email openid profile',
      onLoginSuccess: this.onSocialLogin,
      onLoginFailure: err => {
        this.onLoginFailureInternal(onLoginFailure, err);
      }
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
      width: "equal"
    }, fbSocialButton, gpSocialButton), errors.socialLogin ? /*#__PURE__*/React.createElement(Message, {
      size: "small",
      error: true,
      header: "Trouble authorizing...",
      list: _.concat(errors.socialLogin)
    }) : null);
  }
}
SocialLoginForm.defaultProps = {
  onLoginFailure: undefined
};
export default SocialLoginForm;